import React, { useState } from "react";
import ActivePage from "../../../partials/active-page";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import AlertMessage from "../../../partials/alertMessage";
import { ActivityLog as __q } from "../../../queries/activitylog.query";
import { useQuery } from "react-apollo";
import Loading from "../../../partials/loading";
import LogList from "./loglist";
import Pagination from "../../../partials/pagination";
import DateSearch from "./datesearch";
import LogDetails from "./view";
import { inLoadingState } from "../../../util/loadingState";

const ActivityLog = ({ match }) => {
	const [page] = useState(1);
	const [limit] = useState(25);
	const [showView, setShowView] = useState(false);
	const [currentItem, setCurrentItem] = useState(null);
	const {
		loading: rLoading,
		error: rError,
		data: rData,
		refetch: rRefetch,
		fetchMore: rRefetchMore,
		networkStatus
	} = useQuery(__q.QUERY.GETACTIVITYLOGS, {
		variables: {
			page: page,
			limit: limit
		}
	});

	const title = "Activity Logs";
	const pages = [{ title, path: match.path }];

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>
			<ActivePage title={title} pages={pages} />
			{!showView && (
				<div className="row justify-content-center ">
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 fade-in">
						<DateSearch
							fetch={ranger => {
								rRefetch({ variables: { ranger } });
							}}
						/>
					</div>
				</div>
			)}

			<div className="row">
				{showView && (
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 fade-in">
						<LogDetails
							currentItem={currentItem}
							onBack={() => {
								setShowView(false);
							}}
						/>
					</div>
				)}
				{!showView && (
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 fade-in">
						<div className="card">
							<div className="card-head">
								<div className="tools">
									<a
										className="t-collapse btn-color fa fa-chevron-down"
										href="javascript:;"
									></a>
								</div>
							</div>

							<div className="row justify-content-center">
								<div className={rLoading || rError ? "col-md-8 m-b-20" : ""}>
									{rLoading && <Loading loading={rLoading} />}
									<AlertMessage
										message={rError && rError.message}
										failed={true}
									/>
								</div>
							</div>

							{!rLoading && (
								<>
									<div className="card-body height-9 ">
										<LogList
											list={rData && rData.GetActivityLog.docs}
											onView={p => {
												setCurrentItem(p);
												setShowView(true);
											}}
										/>
										<Loading loading={inLoadingState(networkStatus)} />
									</div>

									{rData && (
										<Pagination
											length={rData.GetActivityLog.docs.length}
											{...rData.GetActivityLog}
											onPageClicked={page => {
												rRefetchMore({
													variables: { page },
													updateQuery: (prev, { fetchMoreResult }) => {
														if (!fetchMoreResult) return prev;
														return {
															GetActivityLog: fetchMoreResult.GetActivityLog
														};
													}
												});
											}}
										/>
									)}
								</>
							)}
						</div>
					</div>
				)}
			</div>
		</>
	);
};

export default ActivityLog;
